
import { Client } from './clientTypes';

export const partners: Client[] = [
  { 
    id: 40, 
    name: "BBE Languages", 
    logoPath: "/lovable-uploads/34d88833-3951-4517-89ed-89266bc04835.png",
    altText: "Logo de BBE Languages" 
  },
  { 
    id: 41, 
    name: "BDS Litter Global", 
    logoPath: "/lovable-uploads/b0c84264-8674-4712-b2e5-90f7e4990002.png",
    altText: "Logo de BDS Litter Global" 
  },
  { 
    id: 42, 
    name: "El Financiero", 
    logoPath: "/lovable-uploads/da4693f7-1ea0-4b26-9eb3-60716f1ccad3.png",
    altText: "Logo de El Financiero" 
  },
  { 
    id: 43, 
    name: "kokoro", 
    logoPath: "/lovable-uploads/945cb84a-d365-4315-9911-b11ccbd5841e.png",
    altText: "Logo de kokoro" 
  },
  { 
    id: 44, 
    name: "La Nación", 
    logoPath: "/lovable-uploads/17ea55e9-8526-4a24-b4b3-89e56d513997.png",
    altText: "Logo de La Nación" 
  },
  { 
    id: 45, 
    name: "La Teja", 
    logoPath: "/lovable-uploads/cf156071-ae78-43a0-a7ba-1a8f3ea3647f.png",
    altText: "Logo de La Teja" 
  },
  { 
    id: 46, 
    name: "PDA", 
    logoPath: "/lovable-uploads/bbe1cdff-9fb2-4b88-91db-287a0736194a.png",
    altText: "Logo de PDA" 
  },
  { 
    id: 47, 
    name: "Psigma Corp", 
    logoPath: "/lovable-uploads/6377940f-0d16-4744-b552-a59ba78762bc.png",
    altText: "Logo de Psigma Corp" 
  },
  { 
    id: 48, 
    name: "Colono", 
    logoPath: "/lovable-uploads/6bd2deca-effd-4098-ae0c-9fa2e7d05dec.png",
    altText: "Logo de Colono" 
  },
  { 
    id: 49, 
    name: "Yuplón", 
    logoPath: "/lovable-uploads/1964eb72-3578-46f2-8340-5d00ef8a0d8a.png",
    altText: "Logo de Yuplón" 
  },
  { 
    id: 50, 
    name: "Partner Logo", 
    logoPath: "/lovable-uploads/3778eca8-796f-4293-b513-70a6044faaf7.png",
    altText: "Logo de Partner" 
  },
  { 
    id: 51, 
    name: "Canatur", 
    logoPath: "/lovable-uploads/bcdde05a-b801-4141-8742-569c650636f8.png",
    altText: "Logo de Canatur - Cámara Nacional de Turismo" 
  },
];
